import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NoData from "../../../components/NoData/Index";
import Axios from "../../../axios/axios";
import RntMiddle from "../../../components/Rental/Layout/RntMiddle";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";

export default function RentalSubCategory() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const categoryId = searchParams.get("categoryId");

  const initialFilters = location.state?.selectedFilters || {
    categoryId: categoryId || "",
  };

  const [categoryData, setCategoryData] = useState(location.state?.category || {});
  const [subcategories, setSubcategories] = useState([]);

  // Fetch category if not passed in state
  useEffect(() => {
    const fetchCategory = async () => {
      if (!categoryData._id && categoryId) {
        try {
          const res = await Axios.get(`/category/get/${categoryId}`);
          setCategoryData(res.data);
        } catch (error) {
          console.error("Error fetching category:", error);
        }
      }
    };
    fetchCategory();
  }, [categoryId, categoryData._id]);

  // Set subcategories whenever categoryData changes
  useEffect(() => {
    if (categoryData?.subcategories?.length > 0) {
      setSubcategories(categoryData.subcategories);
    } else {
      setSubcategories([]);
    }
  }, [categoryData]);

  const handleSubCategoryClick = (subcategory) => {
    const updatedFilters = {
      ...initialFilters,
      categoryId: categoryId, // parent category stays same
      subcategoryId: subcategory._id,
    };

    navigate(
      `/rental/products?${new URLSearchParams(updatedFilters).toString()}`,
      { state: { selectedFilters: updatedFilters } }
    );
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: "50px",
    width: "400px",
    height: "100%",
    backgroundImage: "url(/images/rental-before.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  const afterImageStyle = {
    content: '""',
    position: "absolute",
    right: 0,
    bottom: "290px",
    width: "200px",
    height: "90%",
    backgroundImage: "url(/images/rental-after.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right bottom",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  return (
    <>
      <div className="New-Rnt-Dashboard" style={sectionStyle}>
        <div className="before-image" style={beforeImageStyle}></div>
        <div className="after-image" style={afterImageStyle}></div>
        <div className="Main-div">
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <div className="container">
            <RntMiddle initialFilters={initialFilters} />

            <div className="category-single-page-container mt-4">
              <div className="col-lg-12">
                {/* Back Button */}
                <Link to="/rental/category" className="back">
                  <i className="fa fa-long-arrow-left"></i> Back
                </Link>

                {/* Subcategory Grid */}
                <div className="category-grid mt-4">
                  {subcategories.length === 0 ? (
                    <NoData />
                  ) : (
                    subcategories.map((sub, index) => (
                      <div
                        key={index}
                        className="category-item"
                        onClick={() => handleSubCategoryClick(sub)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={sub.image || sub.images?.[0]}
                            alt={sub.name}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              marginBottom: "10px",
                            }}
                          />
                          <h6>{sub.name}</h6>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
